import * as _ from 'gleam:prelude'

export function new_(fileBits, fileName) {
  return new File([fileBits.rawBuffer], fileName)
}

export async function bytes(file) {
  return new _.BitArray(new Uint8Array(await file.arrayBuffer()))
}

export function text(file) {
  return file.text()
}

export function name(file) {
  return file.name
}

export function mime(file) {
  return file.type
}

export function size(file) {
  return file.size
}

export function createObjectURL(file) {
  return URL.createObjectURL(file)
}

export function readFromEvent(event) {
  const allFiles = event?.dataTransfer?.files ?? event?.target?.files
  if (!allFiles) return new _.Error()
  const files = [...allFiles]
  if (event?.target) event.target.value = ''
  if (files.some(file => file.size >= 200 * 10 ** 6)) return new _.Error()
  return new _.Ok(_.List.fromArray(files))
}

export async function download(name, body) {
  return new Promise(resolve => {
    const blob = new Blob([body.rawBuffer])
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', name)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    resolve()
  })
}
